const originalFetch = window.fetch;
const cartBtn = document.querySelector('.js-header-cart-status-btn');

window.fetch = function(...args) {

    return originalFetch(...args)
        .then(response => {
            const clonedResponse = response.clone();
            
            clonedResponse.json().then(data => {
                if(data.product_title) {
                    cartBtn.click();
                }
               
            });
            return response;
        });
};